module.exports = __webpack_public_path__ + "static/media/AB_iPad_AE_EN.cbb80682.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/AB_iPad_AE_EN.png
// module id = 113
// module chunks = 0